<template>
  <div>
    <transition name="modal">
      <div class="modal-mask-preview-image">
        <div class="modal-wrapper-preview-image" @click="$emit('closeModal')">
          <div class="modal-container-preview-image" @click.stop>

   <div class="modal-header" style="display: flex; justify-content: flex-end; align-items: center; border-bottom: 0; padding-top: 10px; padding-right: 10px;">
              <div style="display: flex; gap: 15px; align-items: center;">
                 <img src="@/assets/img/icon/zoom-in.png" @click="zoomIn" style="width: 25px; height: 25px; cursor: pointer; display: block;" title="Zoom In"/>
                 <img src="@/assets/img/icon/zoom-out.png" @click="zoomOut" style="width: 20px; height: 20px; cursor: pointer; display: block;" title="Zoom Out"/>

                <button @click="downloadImage"
                  style="background: none; border: none; padding: 0; margin: 0; cursor: pointer; line-height: 1;"
                  class="download-btn" title="Download Image">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M16 21.332L9.33331 14.6654L11.2 12.732L14.6666 16.1987V5.33203H17.3333V16.1987L20.8 12.732L22.6666 14.6654L16 21.332ZM5.33331 26.6654V19.9987H7.99998V23.9987H24V19.9987H26.6666V26.6654H5.33331Z"
                      fill="white" />
                  </svg>
                </button>

                <button type="button" @click="$emit('closeModal')"
                  style="color: #fff; background: none; border: none; padding: 0; margin: 0; cursor: pointer; line-height: 1; height: 24px; width: 24px; display: flex; align-items: center; justify-content: center;">
                  <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.4 28L4 25.6L13.6 16L4 6.4L6.4 4L16 13.6L25.6 4L28 6.4L18.4 16L28 25.6L25.6 28L16 18.4L6.4 28Z"
                      fill="white" />
                  </svg>
                </button>
              </div>
            </div>

            <div class="modal-body">
              <!-- Error -->
              <h1 v-if="error.isError" class="text-center text-danger">{{ error.errorMessage }}</h1>

              <!-- Content -->
              <div v-else>
                <!-- Title -->
                <div v-if="config.title" class="row mb-3">
                  <div class="col">
                    <h1 class="text-center">{{ config.title }}</h1>
                  </div>
                </div>

                <!-- Images -->
                <div v-if="imageCollection.length != 0" style="display: flex; flex-direction: column; align-items: center; width: 100%;">
                    <div style="overflow: auto; margin-bottom: 20px; max-height: 80vh; max-width: 90vw; display: inline-block;">
                        <img :src="imageCollection[currentSelected].image" ref="previewImg"
                          :style="imageStyle">
                    </div>
                    <div style="position: relative; z-index: 1000; width: 100%;">
                        <p v-if="imageCollection[currentSelected].description != ''" class="text-center mt-1">{{
                        imageCollection[currentSelected].description }}</p>

                        <div v-if="!config.disableCounter || config.arrow" style="display: flex; justify-content: center; align-items: center; gap: 20px; margin-top: 8px; margin-bottom: 8px;">
                        <div v-if="config.arrow" @click="changeImage(false)"
                            :class="(currentSelected == 0 && config.disableRotation) ? 'arrow-disabled' : 'clickAble'"
                            style="cursor: pointer;">
                            <i class="fas fa-angle-left fa-2x" style="color: white;"></i>
                        </div>
                        <p v-if="!config.disableCounter" style="font-size:18px; color: white; margin: 0;">
                            {{ currentSelected + 1 }} dari {{ imageCollection.length }}
                        </p>
                        <div v-if="config.arrow" @click="changeImage(true)"
                            :class="(currentSelected == imageCollection.length - 1 && config.disableRotation) ? 'arrow-disabled' : 'clickAble'"
                            style="cursor: pointer;">
                            <i class="fas fa-angle-right fa-2x" style="color: white;"></i>
                        </div>
                        </div>
                    </div>
                  </div>


                <!-- Overall Description -->
                <div class="row" v-if="overallDescription != ''">
                  <div class="col">
                    <p :style="overallDescriptionStyle">{{ overallDescription }}</p>
                  </div>
                </div>
              </div>
              <!-- End of Content -->

            </div>
          </div>
        </div>
      </div>

    </transition>
  </div>
</template>

<script>
/*
  [IMPORTANT] - 'image' is REQUIRED

  'image' props content either of:
    > String ('http://www.sampleImage/1.png')
    > Array of String (['http://www.sampleImage/1.png', 'http://www.sampleImage/1.png', 'http://www.sampleImage/1.png'])
    > Array of Object - Contains 'image' and 'description' ([
      {
        'image' : 'http://www.sampleImage/1.png',
        'description' : 'This is a description'
      },
      {
        'image' : 'http://www.sampleImage/1.png'  //No description is also allowed
      },
      {
        'image' : 'http://www.sampleImage/1.png',
        'description' : 'This is a description'
      }
    ])

  *notes:
    - if you only have an image, and you want to put a description on it, you can use the 'description' props
    - you may combine string and object in an array if you would like
    - any other key in the object will be ignored, whilst 'image' is mandatory and 'description' is optional
*/

export default {
  data() {
    return {
      scale: 1, // Start with normal scale
      error: {
        isError: false,
        errorMessage: ''
      },
      config: {
        title: '',

        arrow: true,
        disableRotation: false,
        disableCounter: false,
      },

      //Image List & Current Position
      imageCollection: [],
      currentSelected: 0,

      //Overall Description & It's Style
      overallDescription: '',
      overallDescriptionStyle: '',

      baseWidth: 0,
      baseHeight: 0,
    }
  },
  computed: {
    imageStyle() {
      if (this.scale === 1) {
        return {
          maxWidth: '100%',
          maxHeight: '80vh',
          objectFit: 'contain',
          display: 'block',
          margin: '0 auto'
        };
      }
      return {
        width: `${this.baseWidth * this.scale}px`,
        height: `${this.baseHeight * this.scale}px`,
        maxWidth: 'none',
        maxHeight: 'none',
        display: 'block',
        margin: '0 auto'
      };
    }
  },

  props: [
    'image',//List of images or url of an image - String or Array of String or Array of Object [REQUIRED]
    'title',//Title to be shown at the top - String; DEFAULT null
    'description',//Description for all images - String; DEFAULT null
    'description_style',//Special style for description for all images - String; DEFAULT null
    'hide_arrow',//Hide arrows - Boolean; DEFAULT false (Single string 'image' is excepted to be 'true'; can be overwritten by this)
    'disable_rotation',//Disable rotation or unlimited left or right images - Boolean; DEFAULT false
    'disable_counter',//Disable counter like 1 of 3 - Boolean; DEFAULT false
  ],
  mounted() {
    this.validateProps();
  },
  watch: {
    description: {//REACTIVE
      handler() {
        if (this.description != null) {//Check 'description'
          if (typeof this.description == 'string')
            this.overallDescription = this.description
          else this.declareError("'description' must be a string")
        }
      },
      immediate: true
    },
    description_style: {//REACTIVE
      handler() {
        if (this.description_style != null) {//Check 'description_style'
          if (typeof this.description_style == 'string')
            this.overallDescriptionStyle = this.description_style
          else this.declareError("'description_style' must be a string")
        }
      },
      immediate: true
    }
  },
  methods: {
    async downloadImage() {
      const currentImage = this.imageCollection[this.currentSelected];
      const imageUrl = currentImage.image;

      const link = document.createElement('a');
      link.href = `https://smpm-transporter-dash.qtrust.id/api/download-image?file=${imageUrl}`;
      link.target = '_blank'; // Open in new tab if download fails
      link.style.display = 'none';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    declareError(x) {
      this.error.isError = true;
      this.error.errorMessage = x;
    },
    calculateBaseDimensions() {
      const img = this.$refs.previewImg;
      if (img) {
        // Use getBoundingClientRect or clientWidth/Height to get the rendered size at scale 1
        this.baseWidth = img.clientWidth;
        this.baseHeight = img.clientHeight;
        // Also capture natural dimensions if needed, but rendered size is safer for 'fit' starting point
      }
    },
    zoomIn() {
      if (this.scale === 1) {
        this.calculateBaseDimensions();
      }
      this.scale += 0.5;
    },
    zoomOut() {
      if (this.scale > 1) {
        this.scale -= 0.5;
      }
      if (this.scale < 1) {
        this.scale = 1;
      }
    },
    changeImage(direction) {//false for left, true for right
      this.scale = 1; // Reset zoom on image change
      this.baseWidth = 0;
      this.baseHeight = 0;

      if (direction) {//right
        if (this.currentSelected + 1 <= this.imageCollection.length - 1) this.currentSelected++
        else {
          if (!this.config.disableRotation) this.currentSelected = 0;
          else this.errorPrint('Rotation is disabled');
        }
      } else {//left
        if (this.currentSelected - 1 >= 0) this.currentSelected--
        else {
          if (!this.config.disableRotation) this.currentSelected = this.imageCollection.length - 1;
          else this.errorPrint('Rotation is disabled');
        }
      }
    },
    validateProps() {
      var images = []

      if (this.image != null) {//Check 'image' [REQUIRED]
        if (Array.isArray(this.image)) {
          for (var i in this.image) {
            if (typeof this.image[i] == 'object') {
              if (this.image[i].image == null) this.declareError("One or more object in 'image' props do not contain an 'image' key")
              else if (this.image[i].image.includes('http://') || this.image[i].image.includes('https://'))
                images.push({ image: this.image[i].image, description: this.image[i].description != null ? this.image[i].description : '' })
            } else if (typeof this.image[i] == 'string') {
              if (this.image[i].includes('http://') || this.image[i].includes('https://')) images.push({ image: this.image[i], description: '' })
              else this.declareError("One or more of 'image' props' array contains a non-url string")
            } else this.declareError("One or more of 'image' props' array contains a non-string or a non-object")
          }
        } else if (typeof this.image == 'string') {
          this.config.arrow = false;
          this.config.disableCounter = true;
          if (this.image.includes('http://') || this.image.includes('https://')) images.push({ image: this.image, description: '' })
          else this.declareError("'image' is a non-url string")
        } else this.declareError("'image' must contain either an 'Array of String' or 'String'")
      } else this.declareError("'image' is a required props")

      if (this.title != null) {//Check 'title'
        if (typeof this.title == 'string')
          this.config.title = this.title
        else this.declareError("'title' must be a string")
      }

      //DESCRIPTION AND DESCRIPTION_STYLE CHECK IS DONE ON THE WATCH

      if (this.hide_arrow != null) {//Check 'hide_arrow'
        if (typeof this.hide_arrow == 'boolean')
          this.config.arrow = !this.hide_arrow
        else this.declareError("'hide_arrow' must be a boolean")
      }

      if (this.disable_rotation != null) {//Check 'disable_rotation'
        if (typeof this.disable_rotation == 'boolean')
          this.config.disableRotation = this.disable_rotation
        else this.declareError("'disable_rotation' must be a boolean")
      }

      if (this.disable_counter != null) {//Check 'disable_counter'
        if (typeof this.disable_counter == 'boolean')
          this.config.disableCounter = this.disable_counter
        else this.declareError("'disable_counter' must be a boolean")
      }

      this.imageCollection = images
    },
  }
}
</script>

<style>
.modal-mask-preview-image {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper-preview-image {
  display: table-cell;
  vertical-align: middle;
}

.modal-container-preview-image {
  width: 100vw;
  height: 100vh;
  margin: 0px auto;
  padding: 20px 30px;
  /* background-color: #fff; */
  border-radius: 0;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, .33); */
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow: auto;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 10px 0;
}

.modal-default-button {
  float: right;
}

/*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* MODAL STARTS */
.modal-body {
  margin: 0
}

.modal-body .moduleLine {
  margin-bottom: 0vh;
}

.modal-body .moduleLine a {
  text-decoration: none;
}

.modal-body .moduleLine .moduleBox:hover {
  /* background-color: #E0E0E0; */
  transition: background-color 0.7s ease;
  color: #212121;
  transition: color 0.7s ease;
}

.modal-body .moduleLine .moduleBox {
  /* border:1px solid #BDBDBD; */
  border-radius: 20px;
  padding: 20px 0;
  color: black;
  margin-bottom: 3vh;
}

.modal-body .moduleLine .moduleBox i {
  font-size: 5vh;
}

h3.modalHeadline {
  margin: 0 0 20px 0
}

/* MODAL ENDS */

.modalContent tr th {
  text-align: right;
}

.modalContent tr .middleDivider {
  width: 50px;
  text-align: center;
}



.align-middle {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.clickAble:hover {
  cursor: pointer;
}

.arrow-disabled {
  color: #757575;
}

.download-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
  padding: 0;
  margin: 0;
  line-height: 1;
}

.download-btn:hover {
  color: #42b983;
}
</style>